import React, { useEffect, useState } from 'react';
import NavBar from '../../components/userHomeNavBar/navBar';
import SideBar from '../../components/userHomeSideBar/sideBar';
import EditWidgetCard from './editWidgetCard';  
import ReactLoading from 'react-loading'; 
import { useAuth } from '../../context/DBContext';  
import CreateWidgetModal from '../../components/modals/createWidgetModal';
import DeleteWidgetModal from '../../components/modals/deleteWidgetModal';
import { Timestamp } from 'firebase/firestore';  
import { message } from 'antd';  // Ant Design message for success notification
import {
    LoadingOutlined,
  } from '@ant-design/icons';
import { Spin, Layout, Button, Card, Typography } from 'antd';
const { Content } = Layout;

const AdminWidgetPage = () => {
    const { fetchWidgets, createWidget, deleteWidget, uploadWidgetImage } = useAuth();  
    const [widgets, setWidgets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);  // State for submission loading
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedWidget, setSelectedWidget] = useState(null);
    const [newWidget, setNewWidget] = useState({ topic: '', header: '', description: '', image: null });

    useEffect(() => {
        // Fetch widgets from Firebase when component loads
        const loadWidgets = async () => {
            const fetchedWidgets = await fetchWidgets(); 
            setWidgets(fetchedWidgets);
            setLoading(false);
        };
        loadWidgets();
    }, [fetchWidgets]);

    const handleCreateWidget = async () => {
        try {
          setSubmitting(true);  // Start loading spinner
          let imageUrl = null;
    
          // If there's an image, upload it to Firebase Storage first
          if (newWidget.image) {
            imageUrl = await uploadWidgetImage(newWidget.image); // Use the upload function from context
          }
    
          // Create the widget with the image URL (if available)
          const widgetData = {
            ...newWidget,
            image: imageUrl,  // Store the URL or null if no image
            created_at: Timestamp.now(),
            updated_at: Timestamp.now(),
          };
    
          await createWidget(widgetData);
          message.success('Widget successfully created!');  // Show success message
          
          // Reload widgets after successful creation
          const fetchedWidgets = await fetchWidgets();
          setWidgets(fetchedWidgets);

          setShowCreateModal(false);
          setNewWidget({ topic: '', header: '', description: '', image: null });  // Reset the form
        } catch (error) {
        //   console.error('Error creating widget: ', error);
        } finally {
          setSubmitting(false);  // Stop loading spinner
        }
      };

    const handleDeleteWidget = async () => {
        if (selectedWidget) {
            await deleteWidget(selectedWidget.id);  
            setShowDeleteModal(false);  
            setWidgets(widgets.filter(widget => widget.id !== selectedWidget.id)); // Remove from UI
        }
    };

    return (
       
                        <section >
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Widget Manager
                            </h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <button
                                className="btn btn-primary btn-icon btn-round hidden-sm-down float-right m-l-10"
                                type="button"
                                onClick={() => setShowCreateModal(true)}
                            >
                                <i className="zmdi zmdi-upload" />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Show loading animation while fetching widgets */}
                {loading ? (
                    <div className="flex justify-center items-center h-48">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                    </div>
                ) : (
                    <div className="container-fluid">
                        <div className="row clearfix">
                            {widgets.map(widget => (
                                <EditWidgetCard
                                    key={widget.id}
                                    widgetTopic={widget.topic}
                                    header={widget.header}
                                    description={widget.description}
                                    widgetLink={widget.link}
                                    widgetImage={widget.image} // Pass image URL to EditWidgetCard
                                    ageGroup = {widget.ageGroup}
                                    onDelete={() => {
                                        setSelectedWidget(widget);
                                        setShowDeleteModal(true);
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                )}

                {/* Modal for Creating Widget */}
                <CreateWidgetModal 
                    show={showCreateModal} 
                    onClose={() => setShowCreateModal(false)} 
                    onCreate={handleCreateWidget} 
                    newWidget={newWidget}
                    setNewWidget={setNewWidget}
                    submitting={submitting}  // Pass submitting state to modal
                />

                {/* Modal for Deleting Widget */}
                <DeleteWidgetModal 
                    show={showDeleteModal} 
                    onClose={() => setShowDeleteModal(false)} 
                    onDelete={handleDeleteWidget} 
                />
            </section>);
};

export default AdminWidgetPage;
